function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FB735B;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st6{mask:url(#mask-4_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n\t.st7{fill:#121212;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Group 3");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "picto_green_cloud",
  className: "st0",
  d: "M84.8,115.6c-18.4-13.7-35.8-12-52.5-30.5C17.1,68.2-5.4,74.1,7.5,102.4 c12.9,28.2,34.3,47,57,45.6C87.1,146.5,99.5,126.5,84.8,115.6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st1",
  d: "M41.5,118.2l-2.9,2.1l-4.2-6.8c-1-1.7-2.4-2.5-4-3.3c-0.7,0.8-1.1,1.7-1.8,2.1 c-2,0.6-2.4,0.8-3.9,0c-1.1-0.6-2.1-1.1-3-1.7c-1.9-1.3-3.6-2.7-4.8-5c-1.9-3.7-1.3-6.9,0.2-10.2c1.5-3.4,5.5-5,9-3.8 c0.4,0.1,0.9,0.2,1.5,0.3c0-2.6-0.1-5.1,0.1-7.7c0.6-6.6,1.5-13.1,3.4-19.6c1-3.4,3-6.1,4.7-9.1c1.8-3,4.4-5.2,7-7.3 c4.4-3.4,8.7-6.8,13.3-9.8c4.2-2.8,8.6-5.6,13.4-7.4c1.8-0.7,3.7-1.2,5.5-1.8c0.8-0.3,1.8-0.3,2.2,0.5c0.3,0.6,0.2,1.7-0.2,2.2 c-1.4,1.8-3,3.5-4.6,5.2c-0.7,0.7-1.4,1.4-1.9,2.4c1.9-0.7,3.7-1.4,5.6-1.9c1.4-0.4,3-0.7,4.5-0.6c1.9,0.1,2.5,1.3,1.7,3 c-1,2.3-2.5,4.1-4.4,5.6c-0.9,0.8-1.8,1.6-2.7,2.4c-0.9,0.8-1.8,1.5-2.7,2.2c0.1,0.1,0.2,0.3,0.2,0.4c1.1-0.5,2.2-1,3.3-1.6 c2.5-1.4,4.9-1.5,7.2,0.3c1.5,1.1,2.8,2.3,4.2,3.5c0.6,0.6,0.6,1.2,0.2,1.9c-0.5,0.7-1.2,0.9-1.9,0.5c-1.4-0.7-2.9-1.5-4.1-2.5 c-1.7-1.4-3.3-1.3-5.1-0.5c-2.6,1.3-5.1,2.6-7.8,3.8c-2.6,1.1-5.2,2.1-7.8,3.1c-1,0.4-1.9,0.3-2.5-0.8c-0.5-1,0.2-1.7,0.9-2.2 c2.6-2,5.4-3.8,7.9-5.9c3.2-2.6,6.3-5.4,9.4-8.2c0.6-0.5,1-1.2,1.3-2c-2,0.4-3.9,1.2-5.7,2.1c-3.7,1.9-7.2,4.1-10.6,6.5 c-3.2,2.2-6.6,4.2-9.9,6.3c-1.1,0.7-2,1.6-3.1,2.3c-0.6,0.4-1.2,0.8-1.9,1c-0.4,0.1-1.2-0.2-1.4-0.5c-0.2-0.3-0.1-1.1,0.2-1.5 c0.4-0.6,1.1-1.1,1.7-1.6c4.1-3.2,8.3-6.3,12.2-9.7c4.1-3.5,7.9-7.2,11.8-10.9c0.3-0.2,0.4-0.6,0.6-1.1c-2.6,0.7-5,1.8-7.3,3.2 c-1.4,0.9-2.8,1.8-4.3,2.6c-4,2.1-7.5,4.8-11,7.6c-2.1,1.7-4.3,3.3-6.4,5.1c-2.1,1.8-4.4,3.6-6.1,5.7c-1.4,1.8-2.5,4-3.1,6.1 c-2.9,9.4-3.9,19-3,28.8c0.1,1,0.4,1.9,0.4,2.8c0,0.7-0.2,1.4-0.6,1.9c-0.6,0.7-1.3,0.2-1.9-0.1c-0.8-0.5-1.6-1-2.5-1.5 c-2.5-1.5-5-0.7-6.3,2c-1.2,2.4-0.6,6.2,1.3,8c0.9,0.9,2,1.5,3.1,2.3c1.7,1.1,3.2,1.3,5.1,0.2c1.5-0.9,3.2-0.5,4.7,0.7 c2.7,2.2,4.4,5,6.3,7.8L41.5,118.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  className: "st1",
  d: "M92.4,94.9c-2.2-3.4-4.2-6.9-6.6-10.1c-3.1-4.3-6.6-8.4-9.9-12.6c-0.6-0.7-0.9-1.6-1.2-2.3 c1-0.9,1.6-0.5,2.1,0c1,1,2.1,2,3,3.1c3.2,3.7,6.4,7.4,9.4,11.3c2.4,3.1,4.4,6.4,6.5,9.7c0.4,0.6,0.5,1.4,0.5,2.1 c0.1,1.7-0.8,2.6-2.7,2.6c-1.8,0-3.5-0.5-5.2-1.3c-3-1.5-6.2-2.6-9.3-3.9c-0.4-0.2-1-0.3-1.2-0.7c-0.3-0.5-0.4-1.1-0.2-1.6 c0.1-0.4,0.8-0.8,1.2-0.8c0.8,0,1.6,0.2,2.3,0.5c3.1,1.3,6.2,2.6,9.3,3.9c0.5,0.2,1.1,0.3,1.7,0.4C92.2,95.2,92.3,95.1,92.4,94.9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-5",
  className: "st1",
  d: "M51.6,93.3c0.3-0.7,0.5-1.2,0.6-1.7c0.7-4.6-0.1-9.1-1.5-13.5c-0.3-0.9-0.4-1.9-0.6-2.9 c2.9-0.9,3.7-0.7,4.2,1.7c0.8,4.2,2.2,8.5,1.3,12.8c-0.3,1.5-0.7,3.1-1.3,4.5c-0.9,2.1-2.8,2.4-4.8,0.9c-3.2-2.3-4.4-5.6-5.5-8.9 c-0.7-2-0.9-4.2-1.4-6.2c-0.2-0.9-0.2-1.7,1.1-2.5c0.3,0.7,0.5,1.3,0.7,1.9c1.2,3.2,2.2,6.5,3.5,9.6C48.6,90.8,49.5,92.2,51.6,93.3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-7",
  className: "st1",
  d: "M85.8,69.4c1,0.9,2,1.8,2.9,2.7c1.8,1.9,3.8,3.6,6.3,4.4c0.4,0.1,0.9,0.3,1.3,0.4 c1.4,0.2,2-0.2,1.7-1.6c-0.3-2.1-0.9-4.2-1.4-6.3c-0.5-1.9-1.1-3.7-1.6-5.5c-0.3-0.9,0-1.5,0.8-1.9c0.8-0.4,1.5-0.1,1.9,0.7 c0.2,0.4,0.6,0.7,0.7,1.2c1,2.8,2,5.7,2.7,8.6c0.3,1.3,0.1,2.8,0.2,4.1c0.3,3.2-3.3,4.7-5.6,3.8c-2.2-0.9-4.4-1.8-6.1-3.6 c-1.4-1.6-2.7-3.4-3.9-5.1c-0.3-0.4-0.3-0.9-0.5-1.4C85.6,69.6,85.7,69.5,85.8,69.4"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(59.000000, 96.545455)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-10"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 16.4,
  y: 5,
  width: 15,
  height: 21.5
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 16.4,
  y: 5,
  width: 15,
  height: 21.5,
  id: "mask-2_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st2"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1_1_",
  className: "st3",
  points: "16.4,5 31.4,5 31.4,26.5 16.4,26.5  "
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-9",
  className: "st4",
  d: "M31,16.6c-0.4,1.4-0.8,2.5-1.4,3.6c-0.6,1-1.2,2.1-2.3,3c-0.4,0.3-1,0.9-2.7,1 c-0.9,0.1-2.1-0.1-3.1-0.8c-1-0.7-1.8-1.9-2.2-3.1c-0.4-1.2-0.5-2.5-0.5-3.3c0-0.9,0-1.5,0-1.5s0-0.5,0.1-1.2 c0.1-0.8,0.3-1.8,0.8-2.9c0.4-1.1,1.1-2.2,2-3.1c0.9-0.8,1.9-1.2,2.7-1.2c1,0,1.7,0.6,2.3,1c0.5,0.5,0.9,0.9,1.1,1.2 c0.9,1.3,1.4,2.4,1.9,3.5C30.2,14.1,30.6,15.2,31,16.6c0.4-1.4,0.5-2.7,0.4-4c-0.1-1.3-0.5-2.7-1.6-4.3c-0.3-0.4-0.7-1-1.4-1.6 C27.6,6,26.5,5.1,24.6,5C23,4.9,21.1,5.7,20,6.8c-1.2,1.1-2,2.6-2.5,3.8C17,12,16.7,13.1,16.6,14c-0.1,0.9-0.2,1.4-0.2,1.4 s0,0.6,0,1.6c0,1,0.1,2.4,0.6,4c0.5,1.5,1.5,3.2,3.1,4.2c1.5,1.1,3.4,1.3,4.7,1.2c1.3-0.1,2.2-0.4,2.8-0.7c0.6-0.3,1-0.6,1.3-0.8 c1.7-1.4,2.2-2.9,2.4-4.2C31.5,19.3,31.4,18.1,31,16.6"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(75.090909, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-13"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 16.8,
  y: 5,
  width: 17.4,
  height: 28.4
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 16.8,
  y: 5,
  width: 17.4,
  height: 28.4,
  id: "mask-4_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st5"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-3_1_",
  className: "st3",
  points: "16.8,5 34.1,5 34.1,33.4 16.8,33.4  "
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-12",
  className: "st6",
  d: "M17.4,17.6c0.4-1.7,0.9-3.1,1.4-4.5c0.6-1.3,1.2-2.7,2.3-4c0.5-0.3,1-1.2,3-1.4 c0.7-0.1,1.7,0,2.7,0.1c1.1,0.2,2.3,0.5,3.1,1c0.8,0.5,1.2,1,1.3,1.4c0,0.2,0,0.4,0,0.5c0,0.1,0,0.2,0,0.2c0,0,0,0.3-0.2,0.8 c-0.2,0.5-0.6,1.2-1.2,2c-1.2,1.5-3,3.2-4.4,4.4c-2.6,2.1-3.9,4-4.4,5c-1.2,2-1.4,3.9-1.3,5.5c0.1,1.6,0.4,3.1,0.8,4.8 c0.5-1.9,0.9-3.3,1.2-4.6c0.4-1.4,0.8-2.8,1.7-4.4c0.4-0.8,1.5-2.2,3.9-4.3c1.4-1.2,3.4-3,4.8-4.8c0.7-0.9,1.2-1.8,1.5-2.6 c0.1-0.4,0.3-0.7,0.3-0.9c0-0.2,0.1-0.4,0.1-0.4s0-0.2,0.1-0.4c0-0.3,0-0.8-0.1-1.3c-0.2-1.2-1.3-2.4-2.6-3.1 c-1.3-0.7-2.7-1.1-4-1.3c-1.3-0.2-2.7-0.3-3.7-0.2c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0.1-0.6,0.2-0.9,0.3 c-0.5,0.2-1,0.5-1.3,0.7c-0.7,0.4-1.1,0.9-1.4,1.2c-1.7,1.9-2.1,3.8-2.2,5.4C16.7,14.4,16.9,15.9,17.4,17.6"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-15",
  className: "st1",
  d: "M98.8,38.7c-0.2,0.7-1.6,1.2-3,1.1s-2.5-0.8-2.3-1.5c0.2-0.7,1.6-1.2,3-1.1 C98,37.3,99,38,98.8,38.7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Stroke-17",
  className: "st7",
  d: "M98.8,38.7c-0.2,0.7-1.6,1.2-3,1.1s-2.5-0.8-2.3-1.5c0.2-0.7,1.6-1.2,3-1.1 C98,37.3,99,38,98.8,38.7z"
});

var SvgIllusDelete = function SvgIllusDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115 152.1",
    style: {
      enableBackground: "new 0 0 115 152.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllusDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illus_delete.f770dc29.svg";
export { ForwardRef as ReactComponent };